import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    "KnowledgeIframeTile": () => import("./components/tiles/KnowledgeIframeTile.vue"),
};

export default globals;
